import React from 'react';
import { Target, Rocket, Users, Brain } from 'lucide-react';

export const UniqueFeatures = () => {
  const uniqueFeatures = [
    {
      icon: <Target className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" />,
      title: "ClarityKit™",
      subtitle: "Custom-Curated Sessions",
      description: "Tailored workshops for engineering & tech students based on current industry needs",
      bgColor: "#C4A052",
      iconColor: "#000000"
    },
    {
      icon: <Rocket className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" />,
      title: "Startup Simulator™",
      subtitle: "Real Product Stories",
      description: "Startup journeys & interactive demos from actual industry experiences",
      bgColor: "#6B4423",
      iconColor: "#FFFFFF"
    },
    {
      icon: <Users className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" />,
      title: "Thinkathon™",
      subtitle: "Role-Simulation Workshops",
      description: "Students solve real-world feature by thinking like PMs, QAs, UI/UX designers, and Backend engineers.",
      bgColor: "#FFFFFF",
      iconColor: "#C4A052",
      border: "2px solid #C4A052"
    },
    {
      icon: <Brain className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" />,
      title: "Real World Readiness™",
      subtitle: "Future-Ready Topics",
      description: "Product Thinking, System Design, AI Tools, and Startup Culture",
      bgColor: "#7A9CB5",
      iconColor: "#000000"
    }
  ];

  const handleGetStartedClick = () => {
    window.location.href = '/joinThinkTech';
  };

  return (
    <section className="py-4 sm:py-6 md:py-8" style={{backgroundColor: '#FAF7F2'}}>
      <div className="container mx-auto px-3 sm:px-4 md:px-6">
        <div className="text-center mb-4 sm:mb-6 md:mb-8">
          <div className="inline-flex items-center px-3 sm:px-4 md:px-4 py-2 md:py-2 bg-white rounded-full border-2 font-bold mb-2 sm:mb-2 md:mb-3 shadow-lg" style={{borderColor: '#C4A052', color: '#6B4423'}}>
            <img 
              src="/A2ZAssist%20logo.png" 
              alt="A2Z Assist Logo" 
              className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5 mr-2 md:mr-3 object-contain"
            />
            Why Choose A2ZCampus™
          </div>
          <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold mb-2 sm:mb-3 md:mb-4 px-2" style={{color: '#2C2420'}}>
            Our Proprietary Tools
          </h2>
          <p className="text-sm sm:text-base md:text-base max-w-4xl mx-auto leading-relaxed px-3" style={{color: '#2C2420'}}>
            We don't just teach theory – we share real experiences, practical insights, 
            and actionable strategies that students can apply immediately through our innovative learning tools.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 md:gap-5">
          {uniqueFeatures.map((feature, index) => (
            <div key={index} className="group text-center hover:transform hover:scale-105 transition-all duration-300 bg-white rounded-3xl p-3 sm:p-4 md:p-5 border border-gray-200 shadow-lg hover:shadow-xl">
              <div 
                className="w-10 h-10 sm:w-12 sm:h-12 md:w-16 md:h-16 rounded-3xl flex items-center justify-center mx-auto mb-2 sm:mb-2 md:mb-3 group-hover:scale-110 transition-all duration-300 shadow-lg" 
                style={{
                  backgroundColor: feature.bgColor,
                  border: feature.border || 'none'
                }}
              >
                <div style={{color: feature.iconColor}}>
                  {feature.icon}
                </div>
              </div>
              <h3 className="text-sm sm:text-base md:text-lg font-bold mb-1 group-hover:opacity-80 transition-colors" style={{color: '#2C2420'}}>
                {feature.title}
              </h3>
              <h4 className="text-xs sm:text-sm md:text-base font-semibold mb-2 md:mb-2" style={{color: '#6B4423'}}>
                {feature.subtitle}
              </h4>
              <p className="leading-relaxed text-xs sm:text-xs md:text-sm" style={{color: '#2C2420'}}>
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Additional CTA */}
        <div className="mt-6 sm:mt-8 md:mt-12 text-center">
          <div className="bg-white rounded-3xl p-3 sm:p-4 md:p-6 max-w-5xl mx-auto border-2 shadow-xl" style={{borderColor: '#C4A052'}}>
            <div className="flex flex-col sm:flex-row items-center justify-center mb-2 sm:mb-2 md:mb-3">
              <img 
                src="/A2ZAssist%20logo.png" 
                alt="A2Z Assist Logo" 
                className="w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10 mr-0 sm:mr-3 mb-2 sm:mb-0 object-contain"
              />
              <h3 className="text-base sm:text-lg md:text-xl font-bold text-center sm:text-left" style={{color: '#2C2420'}}>
                Ready to Experience the A2ZCampus™ Difference?
              </h3>
            </div>
            <p className="mb-2 sm:mb-3 md:mb-4 text-xs sm:text-sm md:text-base px-2" style={{color: '#2C2420'}}>
              Join thousands of students who have already transformed their career prospects through our proprietary learning tools.
            </p>
            <button
              onClick={handleGetStartedClick}
              className="px-4 sm:px-6 md:px-8 py-2 sm:py-2 md:py-3 text-white font-bold text-sm sm:text-base md:text-base rounded-2xl hover:opacity-90 transition-all duration-300 transform hover:scale-105 shadow-lg"
              style={{backgroundColor: '#C4A052'}}
              aria-label="Get started with A2ZCampus ThinkTech community"
            >
              Get Started Today
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};